//angular imports
import { signal, Signal, WritableSignal } from "@angular/core";

//local imports
import { IListItem, ListItem, Messenger } from "@app/shared";
import { AbstractRoomContentNavModel, SelectRoomContentMessage } from "@app/catalog-common";
import { RoomContentModel } from "@app/catalog";

export class RoomContentsNavModel 
  extends AbstractRoomContentNavModel<RoomContentModel> {
    
  public override allowMultiSelect?: WritableSignal<boolean> = signal<boolean>(false);
  
 constructor(
    messenger: Messenger,
    items: Signal<RoomContentModel[]>
  ) {
    super(messenger, items);
  }

  public select(item: IListItem): void {
    const navItem = item as ListItem<RoomContentModel>;
    this.messenger.send(new SelectRoomContentMessage(navItem.value));
  }
}